import { enqueueSnackbar } from 'notistack';
import { createMutation } from 'react-query-kit';

import * as Types from '../api/pdf-certificate/types.api';
import * as API from '../api/pdf-certificate/index.api';

//
//

const key = 'pdf-certificate';

//

export const usePurchaseBusinessCertificateGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'business-certificate'],
  mutationFn: (params) => API.getBusinessCertificateAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase certificate successfully downloaded!`, { variant: 'success' });
  },
});

//

export const usePurchaseCustomerCertificateGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'customer-certificate'],
  mutationFn: (params) => API.getCustomerCertificateAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase certificate successfully downloaded!`, {
      variant: 'success',
    });
  },
});

//

export const usePurchaseReceiptGet = createMutation<Blob, Types.PurchaseReceiptQuery>({
  mutationKey: [key, 'receipt'],
  mutationFn: (params) => API.getReceiptAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Purchase receipt successfully downloaded!`, { variant: 'success' });
  },
});

//

export const useCarbonProposalCertificateGet = createMutation<Blob, Types.FootprintProposalQuery>({
  mutationKey: [key, 'carbon-contribution-proposal'],
  mutationFn: (params) => API.getFootprintProposalAPI(params),
  onSuccess: () => {
    enqueueSnackbar(`Carbon contribution proposal successfully downloaded!`, {
      variant: 'success',
    });
  },
});
